<template>
  <div class="nx-block-page-messages">
    <div v-if="roomExists && blocked">
      <v-snackbar
        :bottom="true"
        :right="true"
        :multi-line="true"
        :timeout="0"
        v-model="showSnackbar"
      >
        <template v-if="ownedByCurrentUser">
          {{ $t('message.overlord.ownedByCurrentUser.reason') }}
          <v-btn flat color="info" @click.native="requestUnlock" :loading="loading">
            {{ $t('message.overlord.ownedByCurrentUser.unlock') }}
          </v-btn>
        </template>
        <template v-else>
          {{ $t('message.overlord.ownedByOtherUser.reason', { user: blockedBy }) }}
          <v-btn flat color="info" @click.native="requestUnlock" :loading="loading">
            {{ $t('message.overlord.ownedByOtherUser.unlock') }}
          </v-btn>
        </template>
        <v-btn flat icon @click.native="showSnackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-tooltip v-if="blocked && !showSnackbar" left z-index="1000">
        <v-btn
          class="lock-button"
          slot="activator"
          color="info"
          dark
          fixed
          bottom
          right
          :loading="loading"
          @click.native="requestUnlock"
          fab>
          <v-icon>lock_open</v-icon>
        </v-btn>
        <span>{{ $t('message.overlord.requestUnlock') }}</span>
      </v-tooltip>
    </div>
    <nx-dialog-confirm
      v-show="unlockRequestedByMessage"
      :title="$t('message.overlord.unlockRequestReceived')"
      :text="unlockRequestedByMessage"
      :accept-text="acceptText"
      ref="confirm"
    ></nx-dialog-confirm>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import loadable from '@/mixins/loadable';
import toast from '@/modules/toast/services';
import Confirm from '@/components/dialogs/Confirm';

export default {
  name: 'nx-block-page-message',
  mixins: [loadable],
  components: {
    [Confirm.name]: Confirm,
  },
  data() {
    return {
      countdown: this.replyCourtesyTime / 1000,
      showSnackbar: true,
      unlockRequested: false,
      unlockedBy: null,
    };
  },
  computed: {
    ...mapGetters('room', ['currentRoom']),
    ...mapState({
      replyCourtesyTime: state => state.config.overlordReplyCourtesyTime,
      disabledBlockMessages: state => state.disabledBlockMessages,
    }),
    acceptText() {
      return `Aceptar (${this.countdown})`;
    },
    ownedByCurrentUser() {
      if (this.currentRoom.ownedByUser && this.currentRoom.ownedByUser.id) {
        return this.$store.getters.loggedStaff.id === this.currentRoom.ownedByUser.id;
      }
      return false;
    },
    blockedBy() {
      return this.currentRoom.ownedByUser ? this.currentRoom.ownedByUser.name : '';
    },
    unlockRequestedByUser() {
      return this.currentRoom.ownershipRequestedByUser;
    },
    ownedByMe() {
      return this.$store.getters['room/ownedByMe'] === true;
    },
    blocked() {
      return !this.ownedByMe;
    },
    roomExists() {
      return !!this.currentRoom.id;
    },
    unlockRequestedByMessage() {
      if (!this.currentRoom.ownershipRequestedByUser) {
        return '';
      }
      return this.$t('message.overlord.userUnlockRequest', { userName: this.currentRoom.ownershipRequestedByUser.name });
    },
  },
  methods: {
    resetCountdown() {
      this.countdown = this.replyCourtesyTime / 1000;
    },
    unlockCountdown() {
      if (this.countdown === 0 && this.ownedByMe) {
        this.acceptRequestUnlock();
        this.$refs.confirm.cancel();
      }
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.unlockCountdown();
        }, 1000);
      }
    },
    async requestUnlock() {
      this.loadingStart();
      this.unlockRequested = await this.$store.dispatch('room/REQUEST_CURRENT_ROOM_OWNERSHIP');
      this.unlockedBy = this.blockedBy;
      setTimeout(() => this.loadingFinish(), this.replyCourtesyTime);
    },
    async cancelCurrentRequestUnlock() {
      await this.$store.dispatch('room/CANCEL_CURRENT_ROOM_REQUESTED_OWNERSHIP');
    },
    async acceptRequestUnlock() {
      await this.$store.dispatch('room/ACCEPT_CURRENT_ROOM_REQUESTED_OWNERSHIP');
    },
    async openUnlockRequestConfirmDialog() {
      this.resetCountdown();
      this.unlockCountdown();
      const confirm = await this.$refs.confirm.open();
      if (confirm) {
        this.acceptRequestUnlock();
      } else {
        this.cancelCurrentRequestUnlock();
      }
    },
  },
  watch: {
    unlockRequestedByUser(value) {
      if (value && this.ownedByMe) {
        this.openUnlockRequestConfirmDialog();
      }
      if (!value && this.unlockRequested) {
        if (this.ownedByMe) {
          toast.notify(this.$t('message.overlord.userAcceptRequest', { userName: this.unlockedBy }));
        } else {
          toast.notify(this.$t('message.overlord.userAcceptRequest', { userName: this.unlockedBy }));
        }
        this.unlockRequested = false;
        this.unlockedBy = null;
        this.loadingFinish();
      }
    },
  },
};
</script>
<style lang="stylus">
// force z-index to display button over the modal editor window
.lock-button.v-btn--floating.v-btn--fixed {
  z-index: 1000;
}
</style>
